export const UserRole = {
  NONE: 0,
  NORMAL_ADMIN: 100,
  CONTRACT_ADMIN: 200,
  SUPER_ADMIN: 900,
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];
